var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.fullNameTitle,
            visible: _vm.dialogVisible,
            width: "1000px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "8vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "attendanceKid",
              attrs: {
                "label-width": "120px",
                model: _vm.attendanceKid,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "10px" },
                  attrs: { gutter: 20 },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("div", { staticClass: "shift-card" }, [
                        _c("div", { staticClass: "shift-header" }, [
                          _c("strong", [_vm._v("Điểm danh đến")]),
                        ]),
                        _c("div", { staticClass: "shift-row two-columns" }, [
                          _c(
                            "div",
                            { staticClass: "shift-col shift-media" },
                            [
                              _c("div", { staticClass: "shift-media-title" }, [
                                _vm._v("Ảnh đến"),
                              ]),
                              _c("image-uploader", {
                                attrs: {
                                  preview:
                                    _vm.attendanceKid.attendanceArriveKids
                                      .arriveUrlPicture,
                                  placeholder: "Chưa có ảnh đến",
                                  updateAttendance: false,
                                },
                              }),
                              _c("div", { staticClass: "shift-time" }, [
                                _vm._v("\n                  Giờ đến: "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("formatTime")(
                                        _vm.attendanceKid.attendanceArriveKids
                                          .timeArriveKid
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "shift-col shift-note" },
                            [
                              _c("div", { staticClass: "shift-media-title" }, [
                                _vm._v("Nội dung ghi chú đến"),
                              ]),
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 4,
                                  placeholder: "Chưa có ghi chú",
                                  disabled: "",
                                },
                                model: {
                                  value:
                                    _vm.attendanceKid.attendanceArriveKids
                                      .arriveContent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.attendanceKid.attendanceArriveKids,
                                      "arriveContent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "attendanceKid.attendanceArriveKids.arriveContent",
                                },
                              }),
                              _vm.attendanceKid.attendanceArriveKids
                                .idCreated != null
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "shift-status",
                                      staticStyle: { "margin-top": "20px" },
                                    },
                                    [
                                      _vm.attendanceKid.attendanceArriveKids
                                        .createdDate !==
                                      _vm.attendanceKid.attendanceArriveKids
                                        .lastModifieDate
                                        ? _c("div", [
                                            _vm._v(
                                              "\n                    Điểm danh lần cuối: "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.attendanceKid
                                                    .attendanceArriveKids
                                                    .lastModifieBy
                                                )
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm.attendanceKid
                                              .attendanceArriveKids
                                              .lastModifieBy !== "Hệ thống"
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                    Thời gian: " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatDateTime"
                                                        )(
                                                          _vm.attendanceKid
                                                            .attendanceArriveKids
                                                            .lastModifieDate
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.attendanceKid
                                              .attendanceArriveKids
                                              .guardianPerson
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                      Người đưa đến: "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.attendanceKid
                                                          .attendanceArriveKids
                                                          .guardianPerson
                                                      )
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                          ])
                                        : _c("div", [
                                            _vm._v(
                                              "\n                    Điểm danh: "
                                            ),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.attendanceKid
                                                    .attendanceArriveKids
                                                    .createdBy
                                                )
                                              ),
                                            ]),
                                            _c("br"),
                                            _vm.attendanceKid
                                              .attendanceArriveKids
                                              .createdBy !== "Hệ thống"
                                              ? _c("span", [
                                                  _vm._v(
                                                    "\n                    Thời gian: " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "formatDateTime"
                                                        )(
                                                          _vm.attendanceKid
                                                            .attendanceArriveKids
                                                            .createdDate
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.attendanceKid
                                              .attendanceArriveKids
                                              .guardianPerson
                                              ? _c("div", [
                                                  _vm._v(
                                                    "\n                      Người đưa đến: "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.attendanceKid
                                                          .attendanceArriveKids
                                                          .guardianPerson
                                                      )
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                          ]),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _c("el-divider"),
                    ],
                    1
                  ),
                  _vm.attendanceKid.attendanceLeaveKids &&
                  _vm.attendanceKid.attendanceLeaveKids.idCreated != null
                    ? _c("el-col", { attrs: { span: 24 } }, [
                        _c("div", { staticClass: "shift-card" }, [
                          _c("div", { staticClass: "shift-header" }, [
                            _c("strong", [_vm._v("Điểm danh về")]),
                          ]),
                          _c("div", { staticClass: "shift-row two-columns" }, [
                            _c(
                              "div",
                              { staticClass: "shift-col shift-media" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "shift-media-title" },
                                  [_vm._v("Ảnh về")]
                                ),
                                _c("image-uploader", {
                                  attrs: {
                                    preview:
                                      _vm.attendanceKid.attendanceLeaveKids
                                        .leaveUrlPicture,
                                    placeholder: "Chưa có ảnh về",
                                    updateAttendance: false,
                                  },
                                }),
                                _c("div", { staticClass: "shift-time" }, [
                                  _vm._v("\n                  Giờ về: "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("formatTime")(
                                          _vm.attendanceKid.attendanceLeaveKids
                                            .timeLeaveKid
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "shift-col shift-note" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "shift-media-title" },
                                  [_vm._v("Nội dung ghi chú về")]
                                ),
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    rows: 4,
                                    placeholder: "Chưa có ghi chú",
                                    disabled: "",
                                  },
                                  model: {
                                    value:
                                      _vm.attendanceKid.attendanceLeaveKids
                                        .leaveContent,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.attendanceKid.attendanceLeaveKids,
                                        "leaveContent",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "attendanceKid.attendanceLeaveKids.leaveContent",
                                  },
                                }),
                                _vm.attendanceKid.attendanceLeaveKids
                                  .idCreated != null
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "shift-status",
                                        staticStyle: { "margin-top": "20px" },
                                      },
                                      [
                                        _vm.attendanceKid.attendanceLeaveKids
                                          .createdDate !==
                                        _vm.attendanceKid.attendanceLeaveKids
                                          .lastModifieDate
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                    Điểm danh lần cuối: "
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.attendanceKid
                                                      .attendanceLeaveKids
                                                      .lastModifieBy
                                                  )
                                                ),
                                              ]),
                                              _c("br"),
                                              _vm.attendanceKid
                                                .attendanceLeaveKids
                                                .lastModifieBy !== "Hệ thống"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                    Thời gian sửa: " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatDateTime"
                                                          )(
                                                            _vm.attendanceKid
                                                              .attendanceLeaveKids
                                                              .lastModifieDate
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "\n                    Thời gian sửa: " +
                                                        _vm._s(
                                                          _vm._f("formatTime")(
                                                            _vm.attendanceKid
                                                              .attendanceLeaveKids
                                                              .timeLeaveKid
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                              _vm.attendanceKid
                                                .attendanceLeaveKids
                                                .guardianPerson
                                                ? _c("div", [
                                                    _vm._v(
                                                      "\n                      Người đưa về: "
                                                    ),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.attendanceKid
                                                            .attendanceLeaveKids
                                                            .guardianPerson
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                            ])
                                          : _c("div", [
                                              _vm._v(
                                                "\n                    Điểm danh: "
                                              ),
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.attendanceKid
                                                      .attendanceLeaveKids
                                                      .createdBy
                                                  )
                                                ),
                                              ]),
                                              _c("br"),
                                              _vm.attendanceKid
                                                .attendanceLeaveKids
                                                .createdBy !== "Hệ thống"
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                    Thời gian: " +
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatDateTime"
                                                          )(
                                                            _vm.attendanceKid
                                                              .attendanceLeaveKids
                                                              .createdDate
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      "\n                    Thời gian: " +
                                                        _vm._s(
                                                          _vm._f("formatTime")(
                                                            _vm.attendanceKid
                                                              .attendanceLeaveKids
                                                              .timeLeaveKid
                                                          )
                                                        ) +
                                                        "\n                    "
                                                    ),
                                                  ]),
                                              _vm.attendanceKid
                                                .attendanceLeaveKids
                                                .guardianPerson
                                                ? _c("div", [
                                                    _vm._v(
                                                      "\n                      Người đưa về: "
                                                    ),
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.attendanceKid
                                                            .attendanceLeaveKids
                                                            .guardianPerson
                                                        )
                                                      ),
                                                    ]),
                                                  ])
                                                : _vm._e(),
                                            ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger", size: "medium" },
                  on: {
                    click: function ($event) {
                      return _vm.closeDialogByButton("attendanceKid")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "el-icon-circle-close" }),
                  _vm._v(" Đóng\n      "),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }